import React, { useContext, useState } from 'react';
import { useEffect } from 'react';
import {
  Container,
  Jumbotron,
  Form,
  Col,
  Row,
  Spinner,
  Button,
} from 'react-bootstrap';
import Axios from 'axios';
import { AuthLogin, findUserAndUpdate } from '../utils/NewAuthService';
import { UpdateModal } from '../Components/UpdateModal';
import { storeContext } from '../Store/storeContext';
import { Link } from 'react-router-dom';
const AdminUpdate = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLogged, setLogging] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [courseIdentefiers, setcourseIdentefiers] = useState([]);
  const [listAC, setLSAC] = useState([]);
  const [field, setField] = useState([]);
  const [isUpdated, setisUpdated] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  const [DataAvailable, setDataAvailable] = useState(false);

  const [state, dispatch] = useContext(storeContext);

  const slugGen = (str) => {
    return (str.charAt(0).toLowerCase() + str.slice(1))
      .replace(/\s/g, '')
      .replace(/[^a-zA-Z0-9 ]/g, '');
  };
  const getCurrentUserDetails = async () => {
    function isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    }
    setLogging(true);

    try {
      const response = await AuthLogin(email, password);
      setCurrentUser(response.data.user);
      const courses_registered = response.data.user.courseName;
      const courses_registered_identifiers = response.data.user.roles;
      if (isJson(courses_registered)) {
        setField(JSON.parse(courses_registered));
        setcourseIdentefiers(JSON.parse(courses_registered_identifiers));
        console.log(courses_registered);
      } else {
        setField([courses_registered]);
        setcourseIdentefiers([courses_registered_identifiers]);
        console.log(courses_registered);
      }
      setDataAvailable(true);
      setLogging(false);
    } catch (error) {
      console.log(error)
      setErrorMessage(error.response.data.message);
      setLogging(false);
    }
  };
  const getAvailableCourses = () => {
    Axios({
      url: 'https://graphql.contentful.com/content/v1/spaces/pmwy92zqo6ar/?access_token=nHEca_SIZp5oUECVGuJwQ57-xMDvg9PEzZ1BrEB_zg0',
      method: 'post',
      data: {
        query: `
        {
          pricingCollection {
            items {
              name
            }
          }
        }
          `,
      },
    })
      .then((res) => {
        let AC = res.data.data.pricingCollection.items;
        let newAC = AC.map(({ name }) => name);
        setLSAC(newAC);
      })
      .catch(console.error);
  };
  const handleCheckboxChange = (event) => {
    let newArray = [...field, event.currentTarget.value];
    let newArrayA = [...courseIdentefiers, slugGen(event.currentTarget.value)];
    if (field.includes(event.currentTarget.value)) {
      newArray = newArray.filter((elem) => elem !== event.currentTarget.value);
      newArrayA = newArrayA.filter(
        (elem) => elem !== slugGen(event.currentTarget.value)
      );
    }
    setField(newArray);
    setcourseIdentefiers(newArrayA);
  };

  const updateStudent = (event) => {
    event.preventDefault();
    if (field.length > 0) {
      setisUpdated(true);
      findUserAndUpdate(email,JSON.stringify(courseIdentefiers),JSON.stringify(field))
        .then((resp) => {
          console.log(resp);
          setisUpdated(false);
          dispatch({ type: 'UPDATE_MODAL' });
        })
        .catch(console.error);
    } else {
      alert('You have not selected any course');
    }
  };

  useEffect(getAvailableCourses, []);
  return (
    <Container fluid className='bg-custom min-vh-100'>
      {state.isUpdateModal ? (
        <UpdateModal email={email} courses={field} />
      ) : null}

      <Row className='d-flex justify-content-center p-5'>
        <Jumbotron>
          <Link to='/admin'>
            <Button onClick variant='none' style={{ fontWeight: 'bold' }}>
              Back
            </Button>
          </Link>

          <hr></hr>
          <h2 className='text-center'>Update Current User</h2>
          <Form onSubmit={updateStudent} className='form-custom'>
            <Form.Row>
              <Col md={6}>
                <Form.Group controlId='formBasicEmail'>
                  <Form.Label>Student Email</Form.Label>
                  <Form.Control
                    required
                    onChange={(event) => setEmail(event.target.value)}
                    type='email'
                    placeholder='Email Address'
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId='formBasicPassword'>
                  <Form.Label>Student Password</Form.Label>
                  <Form.Control
                    required
                    onChange={(event) => setPassword(event.target.value)}
                    type='password'
                    placeholder='Password'
                  />
                </Form.Group>
              </Col>
            </Form.Row>
            <Form.Group>
              <p className='text-danger'>{errorMessage}</p>
            </Form.Group>

            <Button
              onClick={getCurrentUserDetails}
              disabled={isLogged}
              variant='inherit'
            >
              {isLogged ? (
                <Spinner size='sm' animation='border'></Spinner>
              ) : (
                'Get User Details'
              )}
            </Button>
            {DataAvailable ? (
              <>
                <p className='text-center p-3 text-danger'>
                  Please Select Courses from the list bellow
                </p>
                <Form.Row className='my-3'>
                  <Form.Group controlId='formBasicCheckbox'>
                    <Form.Label>Registered Courses</Form.Label>

                    {listAC.map((elem) => {
                      return (
                        <Form.Row key={elem}>
                          <Col>
                            <Form.Check
                              type='checkbox'
                              id={`formbasiccheckbox_${elem}`}
                              checked={field.includes(elem)}
                              onChange={handleCheckboxChange}
                              value={elem}
                              label={elem}
                            />
                          </Col>
                        </Form.Row>
                      );
                    })}
                  </Form.Group>
                </Form.Row>
                <Button disabled={isUpdated} variant='inherit' type='submit'>
                  {isUpdated ? (
                    <Spinner size='sm' animation='border'></Spinner>
                  ) : (
                    'Update User'
                  )}
                </Button>
              </>
            ) : null}
          </Form>
        </Jumbotron>
      </Row>
    </Container>
  );
};

export default AdminUpdate;
